'use client';

import { ShieldCheck, Clock, Lock, Star } from 'lucide-react';
import Icon from '@/components/ui/AppIcon';


const signals = [
  {
    icon: ShieldCheck,
    text: 'Verified local professionals',
  },
  {
    icon: Clock,
    text: 'Response within 2 hours',
  },
  {
    icon: Lock,
    text: 'Your info stays private',
  },
  {
    icon: Star,
    text: 'Free — no obligation quotes',
  },
];

export default function TrustSignals() {
  return (
    <div className="grid grid-cols-2 gap-x-4 gap-y-2.5 mt-5">
      {signals?.map(({ icon: Icon, text }) => (
        <div key={text} className="flex items-center gap-2">
          <div className="flex-shrink-0 w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center">
            <Icon className="w-3.5 h-3.5 text-primary" aria-hidden="true" />
          </div>
          <span className="text-xs text-muted-foreground font-500 leading-tight">{text}</span>
        </div>
      ))}
    </div>
  );
}